import { render, staticRenderFns } from "./opening-customer-add-or-update.vue?vue&type=template&id=1e1dfad3&scoped=true"
import script from "./opening-customer-add-or-update.vue?vue&type=script&lang=js"
export * from "./opening-customer-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./opening-customer-add-or-update.vue?vue&type=style&index=0&id=1e1dfad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1dfad3",
  null
  
)

export default component.exports